// based on role ID
enum AdminRoleId {
    BANK_OPS_SUPERVISOR = '1',
    BANK_OPS = '2',
    CLIENT_SERVICES = '3',
    HELP_DESK = '4',
    PCG_ADMIN = '5',
    API_OPS = '6',
    RW_ADMIN = '9',
}

// based on role type
export const AdminRolesMap = {
    0: 'Bank Ops Supervisor',
    1: 'Bank Ops',
    2: 'Client Service',
    3: 'Help Desk',
    4: 'Private Client Group',
    5: 'API Ops',
    8: 'RW Admin',
};

export default AdminRoleId;
